import { CaseSpecification } from '../../../CaseSpecification';
import { isTopLevel } from '../../../../levels/queries/is/isTopLevel';
import { TopLevelSpecification } from '../../../../levels/TopLevelSpecification';

export const getCaseTopLevels = (caseSpecification: CaseSpecification): TopLevelSpecification[] =>
  caseSpecification.levels.filter(isTopLevel);
